import axios from "./axios";

/** Default fields for list/overview (supplier + assignment for dialogs and table). */
export const TOOL_LIST_FIELDS =
  "id,title,tool_number,description,status,active,category,brand,supplier_id,supplier,assigned_user_id,assigned_user,next_service_date,service_overdue,service_due_soon";

// Tools API functions
export const fetchTools = async (controller = {}) => {
  try {
    const params = new URLSearchParams();

    // Add controller parameters
    if (controller.page) params.append("page", controller.page);
    if (controller.per_page) params.append("per_page", controller.per_page);
    if (controller.query) params.append("query", controller.query);
    if (controller.status) params.append("status", controller.status);
    if (controller.category_id)
      params.append("category_id", controller.category_id);
    if (controller.active !== undefined)
      params.append("active", controller.active);
    if (controller.brand_id) params.append("brand_id", controller.brand_id);
    if (controller.assigned_user_id)
      params.append("assigned_user_id", controller.assigned_user_id);
    if (
      controller.assignment &&
      controller.assignment !== "all"
    )
      params.append("assignment", controller.assignment);
    const fields =
      controller.fields !== undefined && controller.fields !== null
        ? controller.fields
        : TOOL_LIST_FIELDS;
    if (fields) params.append("fields", fields);

    const response = await axios.get(`/tools?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tools:", error);
    throw error;
  }
};

export const fetchTool = async (id, fields = null) => {
  try {
    const params = new URLSearchParams();
    if (fields) params.append("fields", fields);

    const response = await axios.get(`/tools/${id}?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool:", error);
    throw error;
  }
};

export const createTool = async (toolData) => {
  try {
    const response = await axios.post("/tools", { tool: toolData });
    return response.data;
  } catch (error) {
    console.error("Error creating tool:", error);
    throw error;
  }
};

export const fetchNextToolNumber = async () => {
  try {
    const response = await axios.get("/tools/next_number");
    return response.data;
  } catch (error) {
    console.error("Error fetching next tool number:", error);
    throw error;
  }
};

export const duplicateTool = async (id) => {
  try {
    const response = await axios.post(`/tools/${id}/duplicate`);
    return response.data;
  } catch (error) {
    console.error("Error duplicating tool:", error);
    throw error;
  }
};

export const updateTool = async (id, toolData) => {
  try {
    const response = await axios.put(`/tools/${id}`, { tool: toolData });
    return response.data;
  } catch (error) {
    console.error("Error updating tool:", error);
    throw error;
  }
};

export const deleteTool = async (id) => {
  try {
    await axios.delete(`/tools/${id}`);
    return { success: true };
  } catch (error) {
    console.error("Error deleting tool:", error);
    throw error;
  }
};

export const fetchToolServiceOverview = async () => {
  try {
    const response = await axios.get("/tools/service_overview");
    return response.data;
  } catch (error) {
    console.error("Error fetching tool service overview:", error);
    throw error;
  }
};

// Tool Categories API functions
export const fetchToolCategories = async (controller = {}) => {
  try {
    const params = new URLSearchParams();

    if (controller.page) params.append("page", controller.page);
    if (controller.per_page) params.append("per_page", controller.per_page);
    if (controller.query) params.append("query", controller.query);
    if (controller.active !== undefined)
      params.append("active", controller.active);

    const response = await axios.get(`/tool_categories?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool categories:", error);
    throw error;
  }
};

export const fetchToolCategory = async (id) => {
  try {
    const response = await axios.get(`/tool_categories/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool category:", error);
    throw error;
  }
};

export const createToolCategory = async (categoryData) => {
  try {
    const response = await axios.post("/tool_categories", {
      tool_category: categoryData,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating tool category:", error);
    throw error;
  }
};

export const updateToolCategory = async (id, categoryData) => {
  try {
    const response = await axios.put(`/tool_categories/${id}`, {
      tool_category: categoryData,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating tool category:", error);
    throw error;
  }
};

export const deleteToolCategory = async (id) => {
  try {
    await axios.delete(`/tool_categories/${id}`);
    return { success: true };
  } catch (error) {
    console.error("Error deleting tool category:", error);
    throw error;
  }
};

// Tool Brands API functions
export const fetchToolBrands = async (controller = {}) => {
  try {
    const params = new URLSearchParams();

    if (controller.page) params.append("page", controller.page);
    if (controller.per_page) params.append("per_page", controller.per_page);
    if (controller.query) params.append("query", controller.query);
    if (controller.active !== undefined)
      params.append("active", controller.active);

    const response = await axios.get(`/tool_brands?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool brands:", error);
    throw error;
  }
};

export const fetchToolBrand = async (id) => {
  try {
    const response = await axios.get(`/tool_brands/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool brand:", error);
    throw error;
  }
};

export const createToolBrand = async (brandData) => {
  try {
    const response = await axios.post("/tool_brands", {
      tool_brand: brandData,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating tool brand:", error);
    throw error;
  }
};

export const updateToolBrand = async (id, brandData) => {
  try {
    const response = await axios.put(`/tool_brands/${id}`, {
      tool_brand: brandData,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating tool brand:", error);
    throw error;
  }
};

export const deleteToolBrand = async (id) => {
  try {
    await axios.delete(`/tool_brands/${id}`);
    return { success: true };
  } catch (error) {
    console.error("Error deleting tool brand:", error);
    throw error;
  }
};
